import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/settings/permission-and-roles/_form",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
